import pt from 'javascript-time-ago/locale/pt'
import en from 'javascript-time-ago/locale/en'
import es from 'javascript-time-ago/locale/es'

export const timeAgoLocales = {
  'pt-BR': pt,
  'en-GB': en,
  'en-US': en,
  'es-AR': es,
}
